import { render, staticRenderFns } from "./lawyer-cards.vue?vue&type=template&id=1aefbe94"
import script from "./lawyer-cards.vue?vue&type=script&lang=js"
export * from "./lawyer-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports